// The edit scope PolicyApp returns with every policy read (PolicyTransactionMessage.editScope):
// whether this session may save the policy and which product-defined field codes stay frozen.
// The codes are SecureMyOffer's SmoFrozenFields; another product publishes its own.

export const FROZEN_FIELDS = {
    RISK_ADDRESS: 'RiskAddress',
    SALE_AMOUNT: 'SaleAmount',
    PROPERTY_SALE_STATUS: 'PropertySaleStatus',
};

export const FROZEN_FIELD_LABEL_IDS = {
    [FROZEN_FIELDS.RISK_ADDRESS]: 'Profile_BoundPolicyNotice.field.riskAddress',
    [FROZEN_FIELDS.SALE_AMOUNT]: 'Profile_BoundPolicyNotice.field.saleAmount',
    [FROZEN_FIELDS.PROPERTY_SALE_STATUS]: 'Profile_BoundPolicyNotice.field.propertySaleStatus',
};

export const isFieldFrozen = (editScope, code) =>
    Array.isArray(editScope?.frozenFields) && editScope.frozenFields.includes(code);
